import React from "react";

import Project from "./project";

import INFO from "../../data/user";
import { useLanguage } from "../../i18n/LanguageContext";

import "./styles/allProjects.css";

const AllProjects = () => {
	const { messages } = useLanguage();

	return (
		<div className="all-projects-container">
			{INFO.projects.map((base, index) => {
				const loc = messages.projects[index];
				if (!loc) return null;
				return (
					<div className="all-projects-project" key={index}>
						<Project
							logo={base.logo}
							title={loc.title}
							description={loc.description}
							linkText={loc.linkText}
							link={base.link}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default AllProjects;
